import { compose, pure, withHandlers, withState } from "recompose";

import CreateProjectSideModal from "./CreateProjectSideModal";
import { FormattedMessage } from "react-intl";
import Queries from "../../queries/queries2";
import React from "react";
import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";
import creationHandlers from "../../containers/Projects/ProjectSettingsContainerHandlers";
import { graphql } from "react-apollo";

const sideModalVisible = withState(
  "sideModalVisible",
  "setSideModalVisible",
  false
);

const inputProject = withState("inputProject", "setInputProject", {});

const handlers = withHandlers({
  createProject: ({ save, onSelected }) => async project => {
    const response = await save(project);
    const newProject = response.data.createProject;
    onSelected({
      label: newProject.name,
      value: newProject.id,
      element: project
    });
  }
});

let ProjectSelect = ({
  value,
  refetch,
  onSelected,
  onSubmit,
  getAllProjects,
  companyId,
  currencyId,
  creatable,
  setSideModalVisible,
  sideModalVisible,
  setInputProject,
  inputProject,
  sendNotification,
  createProject,
  disabled
}) => {
  let options = [];
  getAllProjects &&
    getAllProjects.company &&
    getAllProjects.company.projects &&
    getAllProjects.company.projects.map(project => {
      return options.push({
        label: project.name,
        value: project.id
      });
    });
  // console.log('ProjectSelect options', options)
  return (
    <div>
      <SimpleSelect
        name="Project"
        disabled={(!!disabled && disabled) || false}
        creatable={creatable}
        value={value}
        onSelected={onSelected}
        options={options}
        onNewOptionClick={article => {
          setInputProject(article.value);
          setSideModalVisible(true);
        }}
      />
      {sideModalVisible ? (
        <FormattedMessage id="ids_projects">
          {title => (
            <CreateProjectSideModal
              title={title}
              sendNotification={sendNotification}
              inputProject={inputProject}
              sideModalVisible={true}
              setSideModalVisible={setSideModalVisible}
              companyId={companyId}
              currencyId={currencyId}
              saveProject={project => {
                createProject(project);
                // save
              }}
            />
          )}
        </FormattedMessage>
      ) : (
        <div />
      )}
    </div>
  );
};

ProjectSelect = compose(
  graphql(Queries.GET_ACTIVE_PROJECTS, { name: "getAllProjects" }),
  creationHandlers,
  sideModalVisible,
  inputProject,
  handlers,
  pure
)(ProjectSelect);

export default ProjectSelect;
